import { RankedCardProps } from './RankedCard';
import React from 'react';
import { ProfitLoss } from '../../ProfitLoss';
import { Asset } from '../../Asset/Asset';
import InfoTooltip from '../../InfoTooltip/Info-tooltip';
import { formatDate } from '../../../helpers/functions';
import { useTranslation } from 'react-i18next';

const RankedRow: React.FC<
  Omit<RankedCardProps, 'gradient'> & { className?: string }
> = ({ asset, rank, className = '' }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`flex py-4 border-t dark:border-grey-80 border-grey-10 items-center last:border-b ${className}`}
    >
      <div className="text-base text-grey-70 font-medium ml-5 w-4 text-center">
        {rank}
      </div>
      <div className="flex h-full gap-2 items-center ml-5 w-48">
        <Asset
          id={asset.id}
          name={asset.name}
          logo={asset.logo}
          symbol={asset.symbol}
          type={asset.type || ''}
          exchange={asset.exchange}
        />
      </div>
      <ProfitLoss percentage={asset.percentage} />
      <InfoTooltip
        isTooltipIconVisible
        content={
          <>
            <div>{t('widget.priceChanges.variationBetween')}</div>
            <div>
              {t('widget.priceChanges.variationFrom', {
                date: formatDate(asset.startDate),
              })}
            </div>
            <div>
              {t('widget.priceChanges.variationTo', {
                date: formatDate(asset.endDate),
              })}
            </div>
          </>
        }
        tooltipIconClassName={'ml-1'}
      />
    </div>
  );
};

export default RankedRow;
